import React, { useState, useEffect, forwardRef } from 'react';
import { Sidebar } from '../dashboard_component';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ajaxconfig } from "../ajaxconfig";
import MyTextEditor from './MyTextEditor';
import { Modal } from 'react-bootstrap';
import { 
    private_all_asset, update_cbt_question, diagram_question, 
    SinglePrivateQuestionGet, update_cbt_question_answer, CbtDataIdPrivateCbtDataVerify,
    delete_diagram_question, update_diagram_question, CreateCbtQuestionAnswer, 
    delete_single_answer, add_diagram_to_question 
} from "../serverurl";

const CbtQuestionEdit = () => {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const navigate = useNavigate();
    const [score, setScore] = useState("");
    const [sort, setSort] = useState(1);
    const [questionStatus, setQuestionStatus] = useState("");
    const [displaySort, setDisplaySort] = useState("true");
    const [answer, setAnswer] = useState([]);
    const [dbImgFiles, setDbImgFiles] = useState([]);
    const [dbQuestions, setDbQuestions] = useState("");
    const [diagramLoop, setDiagramLoop] = useState([]);
    const [option, setOption] = useState("");
    const [optionStatus, setOptionStatus] = useState("options");
    const [updateQuestionButtonEffect, setUpdateQuestionButtonEffect] = useState(true);
    const [createOptionButtonEffect, setCreateOptionButtonEffect] = useState(true);
    
    // Modal states
    const [showConfigModal, setShowConfigModal] = useState(false);
    const [showImgModal, setShowImgModal] = useState(false);
    const [showZoomModal, setShowZoomModal] = useState(false);
    const [showEditOptionModal, setShowEditOptionModal] = useState(false);
    const [showDeleteOptionModal, setShowDeleteOptionModal] = useState(false);
    const [currentDiagram, setCurrentDiagram] = useState(null);
    const [currentOption, setCurrentOption] = useState(null);
    const [OptionModal, setOptionsModal] = useState(false);

    // Get URL parameters
    const urlParam = new URLSearchParams(window.location.search);
    const cbtDataPasscode = urlParam.get("cbt_data_id"); 
    const cbtQuestionPasscode = urlParam.get("cbt_question_id"); 
    const config = ajaxconfig();

    const handleToggle = () => setIsCollapsed(!isCollapsed);

    useEffect(() => {
        // Validate CBT data ID
        const url = CbtDataIdPrivateCbtDataVerify + cbtDataPasscode;
        axios.get(url, config).catch(console.error);

        // Fetch all assets
        axios.get(private_all_asset, config)
            .then((response) => {
                setDbImgFiles(response.data.img_files || []);
            }).catch(console.error);

        // Fetch diagram questions
        const diagramQuestionUrl = diagram_question + cbtQuestionPasscode;
        axios.get(diagramQuestionUrl, config)
            .then(response => setDiagramLoop(response.data.diagram || []))
            .catch(console.error);

        // Fetch single question
        const singleQuestionUrl = `${SinglePrivateQuestionGet}/${cbtDataPasscode}/${cbtQuestionPasscode}`;
        axios.get(singleQuestionUrl, config)
            .then(response => {
                const data = response.data.data;
                setDbQuestions(data.cbt_question);
                setAnswer(data.cbt_answer || []);
                setQuestionStatus(data.cbt_question_status || "");
                setDisplaySort(data.display_sort || "true");
                setScore(data.score);
                setSort(data.sort || 1);
            })
            .catch(console.error);
    }, []);

    const refreshQuestion = () => {
        const singleQuestionUrl = `${SinglePrivateQuestionGet}/${cbtDataPasscode}/${cbtQuestionPasscode}`;
        axios.get(singleQuestionUrl, config)
            .then(response => {
                const data = response.data.data;
                setDbQuestions(data.cbt_question);
                setScore(data.score);
                setAnswer(data.cbt_answer || []);
            })
            .catch(console.error);
    };

    const refreshDiagram = () => {
        const diagramQuestionUrl = diagram_question + cbtQuestionPasscode;
        axios.get(diagramQuestionUrl, config)
            .then(response => setDiagramLoop(response.data.diagram || []))
            .catch(console.error);
    };

    const handleQuestionSubmit = (e) => {
        e.preventDefault();
        setUpdateQuestionButtonEffect(false);
        
        const data = {
            cbt_question: dbQuestions,
            cbt_question_id: cbtQuestionPasscode,
            sort: sort,
            cbt_question_status: questionStatus,
            display_sort: displaySort,
            cbt_data_id: cbtDataPasscode,
            score: score
        };
        
        axios.post(update_cbt_question, data, config)
            .then((response) => {
                setUpdateQuestionButtonEffect(true);
                toast.success(response.data.message);
                refreshQuestion();
            })
            .catch((error) => {
                setUpdateQuestionButtonEffect(true);
                toast.error('Failed to update question');
            });
    };

    const handleOptionSubmit = (e) => {
        e.preventDefault();
        setCreateOptionButtonEffect(false);
        
        const submitAnswer = {
            option: option,
            option_status: optionStatus,
            cbt_question_id: cbtQuestionPasscode,
            cbt_data_id: cbtDataPasscode
        };
        
        axios.post(CreateCbtQuestionAnswer, submitAnswer, config)
            .then((response) => {
                toast.success(response.data.message);
                setOption("");
                refreshQuestion();
                setCreateOptionButtonEffect(true);
                setOptionsModal(false);
            })
            .catch((error) => {
                setCreateOptionButtonEffect(true);
                toast.error('Failed to create option');
            });
    };

    const handleChange = (value) => setDbQuestions(value);

    return (
        <div className="flex min-h-screen bg-gray-50">
            <Sidebar isCollapsed={isCollapsed} onToggle={handleToggle} />
            
            <div className={`flex-1 transition-all duration-300 pt-16 lg:pt-5 ${isCollapsed ? 'lg:ml-20' : 'lg:ml-64'}`}>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                    
                    {/* Header Section */}
                    <div className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl shadow-xl overflow-hidden mb-8">
                        <div className="p-6 md:p-8 text-white">
                            <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6">
                                <div className="flex-1">
                                    <h1 className="text-2xl md:text-3xl font-bold mb-2 flex items-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                        </svg>
                                        Edit Question
                                    </h1>
                                    <p className="text-blue-100 text-sm md:text-base">Modify question content, options, and settings</p>
                                </div>
                                <div className="flex flex-wrap gap-3">
                                    <button 
                                        className="bg-white text-blue-600 hover:bg-blue-50 px-4 py-2 rounded-xl font-medium flex items-center gap-2 transition-all duration-200 hover:scale-105"
                                        onClick={() => setShowConfigModal(true)}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                            <path fillRule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clipRule="evenodd" />
                                        </svg>
                                        Settings
                                    </button>
                                    <button 
                                        className="bg-white text-green-600 hover:bg-green-50 px-4 py-2 rounded-xl font-medium flex items-center gap-2 transition-all duration-200 hover:scale-105"
                                        onClick={() => setOptionsModal(true)}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                            <path fillRule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clipRule="evenodd" />
                                        </svg>
                                        Add Option
                                    </button>
                                    <button 
                                        className="bg-white text-purple-600 hover:bg-purple-50 px-4 py-2 rounded-xl font-medium flex items-center gap-2 transition-all duration-200 hover:scale-105"
                                        onClick={() => navigate(`/cbt_creator/cbt_data?cbt_data_id=${cbtDataPasscode}`)}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" clipRule="evenodd" />
                                        </svg>
                                        Back to Questions
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="grid grid-cols-1 xl:grid-cols-3 gap-8">
                        {/* Main Content - Question Editor */}
                        <div className="xl:col-span-2 space-y-8">
                            {/* Question Editor Card */}
                            <div className="bg-white rounded-2xl shadow-sm border border-gray-100">
                                <div className="p-6 border-b border-gray-100">
                                    <h2 className="text-xl font-semibold text-gray-800 flex items-center gap-2">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                        </svg>
                                        Question Content
                                    </h2>
                                </div>
                                <div className="p-6">
                                    <form onSubmit={handleQuestionSubmit}>
                                        <div className="mb-6">
                                            <MyTextEditor
                                                initialContent={dbQuestions}
                                                onChange={handleChange}
                                                imageLibrary={dbImgFiles} 
                                            />
                                        </div>
                                        
                                        <div className="flex justify-end">
                                            <button 
                                                className={`bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white py-3 px-8 rounded-xl font-semibold transition-all duration-200 flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed ${
                                                    !updateQuestionButtonEffect ? 'opacity-75' : 'hover:scale-105'
                                                }`}
                                                type="submit"
                                                disabled={!updateQuestionButtonEffect}
                                            >
                                                {updateQuestionButtonEffect ? (
                                                    <>
                                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                                        </svg>
                                                        Update Question
                                                    </>
                                                ) : (
                                                    <>
                                                        <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                        </svg>
                                                        Saving...
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>

                            {/* Options List Section */}
                            <div className="bg-white rounded-2xl shadow-sm border border-gray-100">
                                <div className="p-6 border-b border-gray-100">
                                    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                                        <h2 className="text-xl font-semibold text-gray-800 flex items-center gap-2">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-600" viewBox="0 0 20 20" fill="currentColor">
                                                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                            </svg>
                                            Options ({answer.length})
                                        </h2>
                                        <button 
                                            className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-xl font-medium flex items-center gap-2 transition-all duration-200 hover:scale-105"
                                            onClick={() => setOptionsModal(true)}
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                                <path fillRule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clipRule="evenodd" />
                                            </svg>
                                            Add Option
                                        </button>
                                    </div>
                                </div>
                                <div className="p-6">
                                    {answer.length > 0 ? (
                                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                                            {answer.map((ans, index) => (
                                                <OptionLoop 
                                                    key={index} 
                                                    answer={ans} 
                                                    onEdit={(option) => {
                                                        setCurrentOption(option);
                                                        setShowEditOptionModal(true);
                                                    }}
                                                    dbImgFiles={dbImgFiles}
                                                    onDelete={(option) => {
                                                        setCurrentOption(option);
                                                        setShowDeleteOptionModal(true);
                                                    }}
                                                />
                                            ))}
                                        </div>
                                    ) : (
                                        <div className="text-center py-12">
                                            <div className="w-24 h-24 mx-auto mb-6 bg-green-100 rounded-full flex items-center justify-center">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                </svg>
                                            </div>
                                            <h3 className="text-xl font-semibold text-gray-700 mb-2">No Options Yet</h3>
                                            <p className="text-gray-500 mb-6">Add options to your question to get started</p>
                                            <button 
                                                className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-xl font-medium flex items-center gap-2 mx-auto transition-all duration-200 hover:scale-105"
                                                onClick={() => setOptionsModal(true)}
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                                    <path fillRule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clipRule="evenodd" />
                                                </svg>
                                                Add First Option
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* Sidebar - Diagrams and Info */}
                        <div className="space-y-8">
                            {/* Diagrams Section */}
                            {/* <div className="bg-white rounded-2xl shadow-sm border border-gray-100">
                                <div className="p-6 border-b border-gray-100">
                                    <h2 className="text-xl font-semibold text-gray-800 flex items-center gap-2">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-purple-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                        </svg>
                                        Diagrams ({diagramLoop.length})
                                    </h2>
                                </div>
                                <div className="p-6">
                                    {diagramLoop.length > 0 ? (
                                        <div className="grid grid-cols-2 gap-4">
                                            {diagramLoop.map((diagram, index) => (
                                                <DiagramLoop 
                                                    key={index} 
                                                    diagram={diagram} 
                                                    onZoom={() => {
                                                        setCurrentDiagram(diagram);
                                                        setShowZoomModal(true);
                                                    }}
                                                />
                                            ))}
                                        </div>
                                    ) : (
                                        <div className="text-center py-6">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                            </svg>
                                            <p className="text-gray-500 mt-2 text-sm">No diagrams added</p>
                                        </div>
                                    )}
                                    <button 
                                        className="w-full mt-4 bg-purple-600 hover:bg-purple-700 text-white py-2.5 rounded-xl font-medium flex items-center justify-center gap-2 transition-all duration-200 hover:scale-105"
                                        onClick={() => setShowImgModal(true)}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                            <path fillRule="evenodd" d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z" clipRule="evenodd" />
                                        </svg>
                                        Add Diagram
                                    </button>
                                </div>
                            </div> */}

                            {/* Question Info Card */}
                            <div className="bg-white rounded-2xl shadow-sm border border-gray-100">
                                <div className="p-6 border-b border-gray-100">
                                    <h2 className="text-xl font-semibold text-gray-800 flex items-center gap-2">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                        Question Info
                                    </h2>
                                </div>
                                <div className="p-6 space-y-4">
                                    <div className="flex justify-between items-center">
                                        <span className="text-gray-600">Status</span>
                                        <span className={`px-3 py-1 rounded-full text-sm font-medium ${
                                            questionStatus === 'published' 
                                                ? 'bg-green-100 text-green-800' 
                                                : 'bg-yellow-100 text-yellow-800'
                                        }`}>
                                            {questionStatus || 'Draft'}
                                        </span>
                                    </div>
                                    <div className="flex justify-between items-center">
                                        <span className="text-gray-600">Score</span>
                                        <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium">
                                            {score || '1'}
                                        </span>
                                    </div>
                                    {/* <div className="flex justify-between items-center">
                                        <span className="text-gray-600">Sort Order</span>
                                        <span className="bg-gray-100 text-gray-800 px-3 py-1 rounded-full text-sm font-medium">
                                            {sort}
                                        </span>
                                    </div> */}
                                    <button 
                                        className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2.5 rounded-xl font-medium transition-all duration-200 hover:scale-105 flex items-center justify-center gap-2"
                                        onClick={() => setShowConfigModal(true)}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                            <path fillRule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clipRule="evenodd" />
                                        </svg>
                                        Configure Settings
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Question Config Modal */}
            <Modal show={showConfigModal} onHide={() => setShowConfigModal(false)} size="lg" centered>
                <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white p-6 rounded-t-lg">
                    <h3 className="text-xl font-bold flex items-center gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                        Question Configuration
                    </h3>
                </div>
                <div className="bg-white p-6">
                    <div className="space-y-6">
                        <div>
                            <label className="block text-gray-700 font-semibold mb-3">Question Status</label>
                            <select 
                                className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                value={questionStatus} 
                                onChange={(e) => setQuestionStatus(e.target.value)}
                            >
                                <option value="published">Published</option>
                                <option value="draft">Draft</option>
                            </select>
                        </div>
                        
                        <div>
                            <label className="block text-gray-700 font-semibold mb-3">Custom Score</label>
                            <input 
                                type="number"
                                className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                value={score}
                                onChange={(e) => setScore(e.target.value)}
                                min="1"
                            />
                        </div>
                        
                        {/* <div>
                            <label className="block text-gray-700 font-semibold mb-3">Sort Order</label>
                            <input 
                                type="number"
                                className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                value={sort}
                                onChange={(e) => setSort(e.target.value)}
                                min="1"
                            />
                        </div> */}
                        
                        <div className="flex justify-end gap-3 pt-4">
                            <button 
                                className="px-5 py-2.5 bg-gray-200 text-gray-800 rounded-xl hover:bg-gray-300 transition-colors font-medium"
                                onClick={() => setShowConfigModal(false)}
                            >
                                Cancel
                            </button>
                            <button 
                                className="px-5 py-2.5 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition-colors font-medium"
                                onClick={() => setShowConfigModal(false)}
                            >
                                Save Changes
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>

            {/* Add Option Modal */}
            <Modal show={OptionModal} onHide={() => setOptionsModal(false)} size="lg" centered>
                <div className="bg-gradient-to-r from-green-600 to-teal-600 text-white p-6 rounded-t-lg">
                    <h3 className="text-xl font-bold flex items-center gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                        </svg>
                        Add New Option
                    </h3>
                </div>
                <div className="bg-white p-6">
                    <form onSubmit={handleOptionSubmit}>
                        <div className="mb-6">
                            <label className="block text-gray-700 font-semibold mb-3">Option Content</label>
                            <MyTextEditor
                                initialContent={option}
                                onChange={setOption}
                                imageLibrary={dbImgFiles} 
                            />
                        </div>
                        
                        <div className="mb-6">
                            <label className="block text-gray-700 font-semibold mb-3">Option Status</label>
                            <select 
                                className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-colors"
                                value={optionStatus} 
                                onChange={(e) => setOptionStatus(e.target.value)}
                            >
                                <option value="options">Regular Option</option>
                                <option value="correct">Correct Answer</option>
                            </select>
                        </div>
                        
                        <div className="flex justify-end gap-3">
                            <button 
                                type="button"
                                className="px-5 py-2.5 bg-gray-200 text-gray-800 rounded-xl hover:bg-gray-300 transition-colors font-medium"
                                onClick={() => setOptionsModal(false)}
                            >
                                Cancel
                            </button>
                            <button 
                                type="submit"
                                className={`px-5 py-2.5 bg-green-600 text-white rounded-xl hover:bg-green-700 transition-colors font-medium flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed ${
                                    !createOptionButtonEffect ? 'opacity-75' : 'hover:scale-105'
                                }`}
                                disabled={!createOptionButtonEffect}
                            >
                                {createOptionButtonEffect ? (
                                    <>
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                            <path fillRule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clipRule="evenodd" />
                                        </svg>
                                        Add Option
                                    </>
                                ) : (
                                    <>
                                        <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                        </svg>
                                        Adding...
                                    </>
                                )}
                            </button>
                        </div>
                    </form>
                </div>
            </Modal>

            {/* Image Selection Modal */}
            <Modal show={showImgModal} onHide={() => setShowImgModal(false)} size="xl" centered>
                <div className="bg-gradient-to-r from-purple-600 to-indigo-600 text-white p-6 rounded-t-lg">
                    <h3 className="text-xl font-bold flex items-center gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                        Select Image to Add
                    </h3>
                </div>
                <div className="bg-white p-6">
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                        {dbImgFiles.map((img, index) => (
                            <QuestionImageLoop 
                                key={index} 
                                data={img} 
                                cbtQuestionId={cbtQuestionPasscode} 
                                onAdd={() => {
                                    setShowImgModal(false);
                                    refreshDiagram();
                                }}
                            />
                        ))}
                    </div>
                    <div className="flex justify-end mt-6">
                        <button 
                            className="px-5 py-2.5 bg-gray-200 text-gray-800 rounded-xl hover:bg-gray-300 transition-colors font-medium"
                            onClick={() => setShowImgModal(false)}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </Modal>

            {/* Diagram Zoom Modal */}
            <Modal show={showZoomModal} onHide={() => setShowZoomModal(false)} size="xl" centered>
                <div className="bg-gradient-to-r from-purple-600 to-indigo-600 text-white p-6 rounded-t-lg">
                    <h3 className="text-xl font-bold flex items-center gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                        Diagram Details
                    </h3>
                </div>
                <div className="bg-white p-6">
                    {currentDiagram && (
                        <DiagramZoom 
                            diagram={currentDiagram} 
                            onDelete={() => {
                                setShowZoomModal(false);
                                refreshDiagram();
                            }}
                            onUpdate={() => {
                                setShowZoomModal(false);
                                refreshDiagram();
                            }}
                        />
                    )}
                </div>
            </Modal>

            {/* Edit Option Modal */}
            <Modal show={showEditOptionModal} onHide={() => setShowEditOptionModal(false)} size="lg" centered>
                <div className="bg-gradient-to-r from-yellow-600 to-orange-600 text-white p-6 rounded-t-lg">
                    <h3 className="text-xl font-bold flex items-center gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                        </svg>
                        Edit Option
                    </h3>
                </div>
                <div className="bg-white p-6">
                    {currentOption && (
                        <OptionEditor 
                            answer={currentOption} 
                            dbImgFiles={dbImgFiles}
                            onUpdate={() => {
                                setShowEditOptionModal(false);
                                refreshQuestion();
                            }}
                        />
                    )}
                </div>
            </Modal>

            {/* Delete Option Confirmation Modal */}
            <Modal show={showDeleteOptionModal} onHide={() => setShowDeleteOptionModal(false)} size="md" centered>
                <div className="bg-gradient-to-r from-red-600 to-pink-600 text-white p-6 rounded-t-lg">
                    <h3 className="text-xl font-bold flex items-center gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                        Confirm Deletion
                    </h3>
                </div>
                <div className="bg-white p-6">
                    {currentOption && (
                        <OptionDeleter 
                            answer={currentOption} 
                            onDelete={() => {
                                setShowDeleteOptionModal(false);
                                refreshQuestion();
                            }}
                            onCancel={() => setShowDeleteOptionModal(false)}
                        />
                    )}
                </div>
            </Modal>

            <ToastContainer 
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </div>
    );
};

// Enhanced DiagramLoop Component
const DiagramLoop = forwardRef(({ diagram, onZoom }, ref) => {
    const [loaded, setLoaded] = useState(false);
    
    return (
        <div 
            ref={ref}
            className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden transition-all duration-300 hover:shadow-md hover:scale-105 cursor-pointer group"
            onClick={onZoom}
        >
            <div className="relative aspect-[4/3] bg-gray-50">
                {!loaded && (
                    <div className="absolute inset-0 bg-gray-200 animate-pulse flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                    </div>
                )}
                <img 
                    src={diagram?.diagram || ""} 
                    alt="Diagram"
                    className={`w-full h-full object-contain p-3 ${loaded ? 'block' : 'invisible'}`}
                    onLoad={() => setLoaded(true)}
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "/placeholder-image.png";
                        setLoaded(true);
                    }}
                />
                <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-10 transition-opacity duration-300 flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white opacity-0 group-hover:opacity-100 transition-opacity" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                </div>
            </div>
            <div className="p-3 border-t border-gray-100">
                <p className="text-sm text-gray-600 truncate" title={diagram.description || 'No description'}>
                    {diagram.description || 'No description'}
                </p>
            </div>
        </div>
    );
});

// Enhanced QuestionImageLoop Component
const QuestionImageLoop = forwardRef(({ data, cbtQuestionId, onAdd }, ref) => {
    const [description, setDescription] = useState("");
    const [loading, setLoading] = useState(false);
    const config = ajaxconfig();

    const handleAdd = () => {
        setLoading(true);
        const datas = {
            cbt_question_id: cbtQuestionId,
            diagram: data.file_name,
            description: description
        };
        
        axios.post(add_diagram_to_question, datas, config)
            .then(() => {
                setLoading(false);
                onAdd();
                toast.success('Diagram added successfully');
            })
            .catch((error) => {
                setLoading(false);
                toast.error('Failed to add diagram');
            });
    };
    
    return (
        <div 
            ref={ref}
            className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden transition-all duration-300 hover:shadow-md hover:scale-105 h-full flex flex-col"
        >
            <div className="relative aspect-[4/3] bg-gray-50">
                <img 
                    src={data.file_name}
                    alt="Uploaded content"
                    className="w-full h-full object-contain p-4"
                />
            </div>
            <div className="p-4 flex flex-col flex-grow">
                <input 
                    type="text" 
                    className="w-full px-3 py-2 mb-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition text-sm"
                    placeholder="Enter description" 
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                />
                <button 
                    onClick={handleAdd}
                    disabled={loading}
                    className="mt-auto flex items-center justify-center px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg transition disabled:opacity-50 disabled:cursor-not-allowed text-sm font-medium"
                >
                    {loading ? (
                        <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                    ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                        </svg>
                    )}
                    Add to Question
                </button>
            </div>
        </div>
    );
});

// Enhanced OptionLoop Component
const OptionLoop = forwardRef(({ answer, onEdit, onDelete, dbImgFiles }, ref) => (
    <div 
        ref={ref}
        className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden transition-all duration-300 hover:shadow-md hover:scale-105"
    >
        <div className={`px-4 py-3 ${answer.option_status === 'correct' ? 'bg-gradient-to-r from-green-500 to-emerald-500' : 'bg-gradient-to-r from-gray-500 to-gray-600'} text-white`}>
            <div className="flex justify-between items-center">
                <div className="flex items-center">
                    {answer.option_status === 'correct' ? (
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white mr-2" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                        </svg>
                    ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white mr-2" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm0-2a6 6 0 100-12 6 6 0 000 12z" clipRule="evenodd" />
                        </svg>
                    )}
                    <span className="text-sm font-medium">
                        {answer.option_status === 'correct' ? 'Correct Answer' : 'Option'}
                    </span>
                </div>
                <div className="flex gap-2">
                    <button 
                        onClick={() => onEdit(answer)}
                        className="p-1.5 text-white hover:bg-white hover:bg-opacity-20 rounded-full transition"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                        </svg>
                    </button>
                    <button 
                        onClick={() => onDelete(answer)}
                        className="p-1.5 text-white hover:bg-white hover:bg-opacity-20 rounded-full transition"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
        <div className="p-4 text-gray-700 prose prose-sm max-w-none" dangerouslySetInnerHTML={{ __html: answer.options }} />
    </div>
));

// Enhanced OptionEditor Component
const OptionEditor = ({ answer, onUpdate, dbImgFiles }) => {
    const [option, setOption] = useState(answer.options || "");
    const [optionStatus, setOptionStatus] = useState(answer.option_status || "options");
    const [loading, setLoading] = useState(false);
    const config = ajaxconfig();
    
    const handleSubmit = () => {
        setLoading(true);
        const data = {
            option: option,
            cbt_question_id: answer.cbt_question_id,
            cbt_option_id: answer.answer_id,
            cbt_pass_code: answer.cbt_data_id,
            option_status: optionStatus
        };
        
        axios.post(update_cbt_question_answer, data, config)
            .then(() => {
                setLoading(false);
                onUpdate();
                toast.success('Option updated successfully');
            })
            .catch((error) => {
                setLoading(false);
                toast.error('Failed to update option');
            });
    };
    
    return (
        <div className="space-y-6">
            <div>
                <label className="block text-gray-700 font-semibold mb-3">Option Content</label>
                <MyTextEditor
                    initialContent={option}
                    onChange={setOption}
                    imageLibrary={dbImgFiles} 
                />
            </div>
            
            <div>
                <label className="block text-gray-700 font-semibold mb-3">Option Status</label>
                <select 
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500 transition"
                    value={optionStatus}
                    onChange={(e) => setOptionStatus(e.target.value)}
                >
                    <option value="options">Regular Option</option>
                    <option value="correct">Correct Answer</option>
                </select>
            </div>
            
            <div className="flex justify-end gap-3">
                <button 
                    onClick={() => onUpdate()}
                    className="px-5 py-2.5 bg-gray-200 text-gray-800 rounded-xl hover:bg-gray-300 transition-colors font-medium"
                >
                    Cancel
                </button>
                <button 
                    onClick={handleSubmit}
                    disabled={loading}
                    className="px-5 py-2.5 bg-yellow-600 hover:bg-yellow-700 text-white rounded-xl transition-colors font-medium flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    {loading ? (
                        <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                    ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                    )}
                    Update Option
                </button>
            </div>
        </div>
    );
};

// Enhanced OptionDeleter Component
const OptionDeleter = ({ answer, onDelete, onCancel }) => {
    const [loading, setLoading] = useState(false);
    const config = ajaxconfig();
    
    const handleDelete = () => {
        setLoading(true);
        const deleteData = {
            cbt_pass_code: answer.cbt_data_id,
            cbt_question_id: answer.cbt_question_id,
            cbt_answer_id: answer.answer_id
        };
        
        axios.post(delete_single_answer, deleteData, config)
            .then(() => {
                setLoading(false);
                onDelete();
                toast.success('Option deleted successfully');
            })
            .catch((error) => {
                setLoading(false);
                toast.error('Failed to delete option');
            });
    };
    
    return (
        <div className="space-y-6">
            <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded-xl">
                <p className="text-red-700 font-medium">
                    Are you sure you want to delete this option? This action cannot be undone.
                </p>
            </div>
            
            <div className="border border-gray-200 rounded-xl p-4 bg-gray-50">
                <div className="prose prose-sm max-w-none" dangerouslySetInnerHTML={{ __html: answer.options }} />
            </div>
            
            <div className="flex flex-col sm:flex-row justify-end gap-3">
                <button 
                    onClick={onCancel}
                    disabled={loading}
                    className="px-5 py-2.5 border border-gray-300 text-gray-700 hover:bg-gray-50 rounded-xl transition-colors font-medium disabled:opacity-50"
                >
                    Cancel
                </button>
                <button 
                    onClick={handleDelete}
                    disabled={loading}
                    className="px-5 py-2.5 bg-red-600 hover:bg-red-700 text-white rounded-xl transition-colors font-medium flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    {loading ? (
                        <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                    ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                    )}
                    Delete Permanently
                </button>
            </div>
        </div>
    );
};

// Enhanced DiagramZoom Component
const DiagramZoom = ({ diagram, onDelete, onUpdate }) => {
    const [description, setDescription] = useState(diagram.description || "");
    const [loading, setLoading] = useState(false);
    const config = ajaxconfig();
    
    const handleUpdate = () => {
        setLoading(true);
        const data = {
            id: diagram.id,
            description: description
        };
        
        axios.post(update_diagram_question, data, config)
            .then(() => {
                setLoading(false);
                onUpdate();
                toast.success('Diagram updated successfully');
            })
            .catch((error) => {
                setLoading(false);
                toast.error('Failed to update diagram');
            });
    };
    
    const handleDelete = () => {
        setLoading(true);
        const data = {
            id: diagram.id,
            cbt_question_id: diagram.cbt_question_id,
            file_name: diagram.diagram
        };
        
        axios.post(delete_diagram_question, data, config)
            .then(() => {
                setLoading(false);
                onDelete();
                toast.success('Diagram deleted successfully');
            })
            .catch((error) => {
                setLoading(false);
                toast.error('Failed to delete diagram');
            });
    };
    
    return (
        <div className="space-y-6">
            <div className="bg-gray-50 rounded-xl p-6 flex justify-center">
                <img 
                    src={diagram.diagram} 
                    alt="Diagram" 
                    className="max-h-[60vh] max-w-full object-contain rounded-lg"
                />
            </div>
            
            <div>
                <label className="block text-gray-700 font-semibold mb-3">Description</label>
                <input 
                    type="text" 
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition"
                    value={description} 
                    onChange={(e) => setDescription(e.target.value)}
                    placeholder="Enter description"
                />
            </div>
            
            <div className="flex flex-col sm:flex-row justify-between gap-3">
                <button 
                    onClick={handleDelete}
                    disabled={loading}
                    className="flex items-center justify-center px-5 py-2.5 bg-red-600 hover:bg-red-700 text-white rounded-xl transition-colors font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    {loading ? (
                        <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                    ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                    )}
                    Delete Diagram
                </button>
                
                <button 
                    onClick={handleUpdate}
                    disabled={loading}
                    className="flex items-center justify-center px-5 py-2.5 bg-purple-600 hover:bg-purple-700 text-white rounded-xl transition-colors font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    {loading ? (
                        <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                    ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                    )}
                    Update Description
                </button>
            </div>
        </div>
    );
};

export { CbtQuestionEdit };